import { render, staticRenderFns } from "./VersionInfoDialog.vue?vue&type=template&id=70029a5e&scoped=true"
import script from "./VersionInfoDialog.vue?vue&type=script&lang=js"
export * from "./VersionInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./VersionInfoDialog.vue?vue&type=style&index=0&id=70029a5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70029a5e",
  null
  
)

export default component.exports